/* eslint import/no-import-module-exports: off */
import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import rootReducer from '../redux';

export const history = createBrowserHistory();

export default function configureStore(preloadedState) {
  const devtoolsCompose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const composeEnhancer =
    process.env.ENVIRONMENT === 'smoke' || process.env.ENVIRONMENT === 'production'
      ? compose
      : devtoolsCompose;
  const middleware = [routerMiddleware(history), thunk].filter(Boolean);

  const store = createStore(
    rootReducer(history),
    preloadedState,
    composeEnhancer(applyMiddleware(...middleware))
  );

  // Hot reloading
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../redux', () => {
      store.replaceReducer(rootReducer(history));
    });
  }

  return store;
}
